<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-7 col-md-12 text-left tasks-header">
        <img class="user-header-logo" :src="currentUser.avatar">
        <div class="header-text">
          <h1>My Tasks</h1>
        </div>
      </div>
    </div>
    <TicketWrapper :user="true" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TicketWrapper from './TicketWrapper'
import ShowActivity from './ShowActivity'
export default {
  name: 'Tasks',
  components: {
    TicketWrapper,
    ShowActivity
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  },
  mounted () {
  },
  watch: {
  }
}
</script>

<style scoped>
.header-text {
  display: inline-block;
  margin-top: 12px;
  margin-left: 5px;
}
.header-text h1{
  font-size: 20px;
  margin-bottom: -5px;
}
.user-header-logo {
  vertical-align: top;
  border-radius: 50%;
  height: 50px;
}
 .tasks-header {
   margin: 15px 0 15px 15px;
 }
</style>
<style>
   .table-edit a:visited {
     color: #0563C1;
   }

</style>



// WEBPACK FOOTER //
// src/components/Tasks.vue